export const StillAndMovingImagesDefault = [
    { span: 8, height: "27px" },
    { span: 8, height: "224px", classes: "marginTop-8" },
    { span: 8, height: "18px", classes: "marginTop-8" },
    { span: 8, height: "18px", classes: "marginTop-8" },
]

export const StillAndMovingImagesWithoutHeader = [
    { span: 8, height: "224px" },
    { span: 8, height: "18px", classes: "marginTop-8" },
    { span: 8, height: "18px", classes: "marginTop-8" },
]

export const StillAndMovingImagesWithoutHeaderAndCaption = [
    { span: 8, height: "224px" },
    { span: 8, height: "18px", classes: "marginTop-8" },
]
